export const DAYS = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
export const MONTHS = [
    'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni',
    'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'
];
/** Deutsches Zahlenformat (Komma statt Punkt). */
export function de(v, digits) {
    return v.toFixed(digits).replace('.', ',');
}
export function today() {
    const d = new Date();
    return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
}
export function parse(s) {
    return new Date(s + 'T12:00:00');
}
export function shift(s, n) {
    const d = parse(s);
    d.setDate(d.getDate() + n);
    return d.toISOString().slice(0, 10);
}
export function dayOf(s) {
    return DAYS[parse(s).getDay()];
}
export function dateText(s) {
    const d = parse(s);
    return `${d.getDate()}.${d.getMonth() + 1}.`;
}
export function headerDate(t) {
    const d = parse(t);
    return `${dayOf(t)}, ${d.getDate()}. ${MONTHS[d.getMonth()]}`;
}
/** "heute gemessen" / "gestern gemessen" / "vor N Tagen" */
export function ago(s, t) {
    const days = Math.round((parse(t).getTime() - parse(s).getTime()) / 86400000);
    if (days === 0)
        return 'heute gemessen';
    if (days === 1)
        return 'gestern gemessen';
    return `vor ${days} Tagen`;
}
export function daysBetween(a, b) {
    return Math.round((parse(a).getTime() - parse(b).getTime()) / 86400000);
}
